import React from 'react';
import ReactDOM from 'react-dom'
import Reflux from 'reflux';
import FormItemConst from '../../formItem/FormItemConst';
import FormLookupFactory from '../../utils/FormLookupFactory';
import StringUtil from '../../utils/StringUtil';
import ToolBarUtil from '../../utils/ToolBarUtil';
import LookupReturnStore from '../../stores/LookupReturnStore';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';
import Warn from '../../utils/Warn';
import CommandResolver from '../../utils/CommandResolver';
import CommandHelper from '../../remote/CommandHelper';
import ServiceHelper from '../../remote/ServiceHelper';

export default class DialogFieldStringEditor extends React.Component
{
	constructor(props) {
		super(props);
		this.initMembers();
		this.classAlias = "DialogFieldStringEditor";
		this.state = {data:this.props.data};
		this.hasLookup = true;
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	lookupStates = 
	{
		isShowed:false,
		dropdownform:null
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			//alert("侦听到了");
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	onLookupReturn(value,entityId,innerId)
	{
		if(this.state.data.entityId == entityId && null == innerId)
		{
			//alert("侦听到");
			this.closeDropDown();
			
			this.onLookupReturning = true;
			$(this.inputField).val(value);
			this.inputField.focus();
			this.inputField.select();
			this.onLookupReturning = false;
			return false;
		}
	}

	initMembers()
	{
		this.lookupEvents = [
			[$(document), {
				'mousedown touchstart': $.proxy(function(e){					
					if (!(
						$(this.inputgroup).is(e.target) ||
						$(this.inputgroup).find(e.target).length ||
						this.lookupStates.dropdownform.is(e.target) ||
						this.lookupStates.dropdownform.find(e.target).length
					)){
						this.closeDropDown();
					}
				}, this)
			}]
		];
		this.toolBarObject = ToolBarUtil.createToolBarObj_Form_FormLookup();
	}

	getTextAreaDom(displayHeight)
	{
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		if(this.state.data.allowEdit)
		{
			let _style = {resize:'none',padding:'2px'};
		 	return	<textarea ref={node => this.inputField = node} id={"input"+this.state.data.id} defaultValue={_defaultValue}
		 				  className="form-control" rows={displayHeight}  style={_style}></textarea>
		}
		else
		{
			let _style = {resize:'none',padding:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR};
		 	return	<textarea ref={node => this.inputField = node} id={"input"+this.state.data.id}  readOnly="readonly" 
		 				  className="form-control" rows={displayHeight}  style={_style}  defaultValue={_defaultValue}></textarea>
		}
	}

	inputFieldBlur(e)
	{
		if(this.lookupStates.isShowed)
			return;
		var oldValue = this.record;
		if(!oldValue)oldValue = "";
		var value = $(this.inputField).val();
		this.record = value;
		var newValue = value;
		this.doModifiedEditor(oldValue,newValue);
	}

	doModifiedEditor(oldValue,newValue)
	{
		var editorName = this.props.data.id;
		var mi =  {groups:"current(3)",editors:"all",joinGroup:null,fetchOption:true};
		var formmodule = window.formModuleInstance;
		var defaultGroupAlias = "";
		if(formmodule.formDataSources && formmodule.formDataSources.firstGroup)
		{
			defaultGroupAlias = formmodule.formDataSources.firstGroup.groupAlias;
		}
		var arg = CommandResolver.getSendCmd(formmodule, defaultGroupAlias, mi);		
		
		var command = CommandHelper.createFormInstance(formmodule.formName,"doDialogModifiedEditor","Object");
		
		command.appendArg("String", "String")
				.appendArg(oldValue+"", "Object")
				.appendArg(newValue+"", "Object")
				.appendArg(this.props.data.entityId,"String")
				.appendArg(arg,"CommandArg");
		var _group = formmodule.formDataSources?formmodule.formDataSources.firstGroup:null;
		var _rpc_fault_doModifiedEditor = this.rpc_fault_doModifiedEditor.bind(this);
		
		var remoteArg = {
			command:command,
			resultFunction:function(data)
			{
				$(this.inputField).val(data.result);
				//CommandResolver.resolve(data.result.tasks, formmodule,_group);
			},
			faultFunction:function(data)
			{
				_rpc_fault_doModifiedEditor(data, oldValue, newValue);
			}
		};
		ServiceHelper.addTokenWithCommand(remoteArg);
		
	}

	rpc_fault_doModifiedEditor(data, oldValue, newValue)
	{
		var faultString;
		if(data && data.successButNot0)
		{
			faultString = data.errText;
		}
		else
		{
			faultString = "可能是网络错误 请检查网络是否正常";
		}

		var info = "变更值失败：" + oldValue + " -> " + newValue + "<br/>" + "已恢复到：" + oldValue+ "<br/>" + "失败原因为：" + faultString;
		Warn.show({text:info,title:"此次操作未能成功"});
		this.record = oldValue;
		$(this.inputField).val(oldValue);
	}

	getInputDom(_width)
	{
		let _allowEdit = this.state.data.allowEdit;
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		this.record = _defaultValue;
		let _type = "text";
		let _id = this.state.data.id;
		if(typeof(_id) == "string")
		{
			if(_id.indexOf("password") != -1)
				_type = "password";
		}
		if(_allowEdit)
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',fontSize:"12px",width:_width};
			return	<input spellCheck="false" ref={node => this.inputField = node} className="form-control" 
						id={"input"+this.state.data.id} type={_type}  style={_style} 
						defaultValue={_defaultValue} onKeyDown={this.onKeyDownHandler.bind(this)}
						onBlur={this.inputFieldBlur.bind(this)}/>;
		}
		else
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px",width:_width};
			return	<input spellCheck="false" ref={node => this.inputField = node} className="form-control" 
						id={"input"+this.state.data.id} type={_type}  style={_style} 
						defaultValue={_defaultValue} readOnly="readonly"/>;
		}
	}

	getDownArrowButtonDom()
	{
		let _allowEdit = this.state.data.allowEdit;
		if(_allowEdit && this.hasLookup)
		{
			/*return	(<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 6px 4px'}}  onMouseDown={this.buttonDownClick.bind(this)}>
	        			<i className="fa fa-sort-desc"></i>
					</span>);*/
			return <i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		}
		else if(_allowEdit)
		{
			/*return	(<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 6px 4px',display:"none"}}  onMouseDown={this.buttonDownClick.bind(this)}>
	        			<i className="fa fa-sort-desc"></i>
					</span>);*/
			return <i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',display:'none',zIndex:3}}></i>;
		}
	}

	onKeyDownHandler(e)
	{
		if(40===e.keyCode || 38===e.keyCode)
		{
			//let ne = e["nativeEvent"];
			if(this.lookupStates.isShowed)
			{
				e.preventDefault();
				e.stopPropagation();
				if(e.ctrlKey && e.keyCode == 38)
				{
					this.closeDropDown();
				}
			}
			else if(e.ctrlKey && e.keyCode == 40)
			{
				e.preventDefault();
				e.stopPropagation();
				if($(this.downArrowButton).is(":visible"))
					this.showDropDown();
			}
			
		}
		else if(27 == e.keyCode && this.lookupStates.isShowed)
		{
			e.preventDefault();
			e.stopPropagation();
			this.closeDropDown();
		}
	}

	getLookupBase()
	{
		var base = {};
		base["entityId"] = this.state.data.entityId;
		base["innerId"] = null;
		base["formType"] = "Dialog";
		return base;
	}

	checkDropDownHas()
	{
		var base = this.getLookupBase();
		let _group = null;
		if(this.state.data.groupId)
		{
			if(window.formModuleInstance.formDataSources)
				_group = window.formModuleInstance.formDataSources.groups[this.state.data.groupId];
		}

		
		if(!FormLookupFactory.hasFormLookup(base, this.state.data.entityId, _group))//如果GOT没有 则设置为false
		{	
			$(this.downArrowButton).hide();this.hasLookup = false;
		}
	}

	buttonDownClick(e)
	{
		if(!(
			$(this.inputgroup).is(document.activeElement) || 
			$(this.inputgroup).find(document.activeElement).length	

		))
			e.preventDefault();
		return this.showDropDown();
	}

	detachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
	}
	
	componentWillUnmount()
	{
		//alert("DialogFieldStringEditor unMount");
		this.unsubscribeDiaLogMapEditorsStore();
		this.closeDropDown();
	}

	closeDropDown()
	{
		
		if(this.lookupStates.isShowed)
		{
			let lookupdiv = this.lookupStates.dropdownform;
			if(lookupdiv == null)
				return;
			this.detachEventListeners();
			this.unsubscribeLookupReturnStore();
			lookupdiv.remove();
			
			this.moduleLookup = null;
			
			this.lookupStates.isShowed = false;
			
			//this.refs.inputdom.focus();this.refs.inputdom.select();
			this.inputField.focus();
			this.inputField.select();

			window.lookupShowing = false;
			/*var _parentWindow = window.parent.window;
		    if(_parentWindow)
		    {
		       _parentWindow.setToolBar(window.toolBarObject);
		    }*/
		    
			return false;	
		}

	}

	showDropDown()
	{
		let lookupdiv = this.lookupStates.dropdownform;
		
		//暂时把下拉框缓存在项目编辑器实例 由于项目编辑器实例会由reactdatagrid销毁
		//所以缓存对于FormItemStringEditorForDataGrid不适用 应该跟flex一样缓存到全局
		if(lookupdiv==null)
		{
			lookupdiv = $("<div>").css({position:'absolute',padding:'1px',backgroundColor:'#ffffff',border:'solid 1px #d2d2d2',/*float:'left',*/zIndex:1051});
			this.lookupStates.dropdownform = lookupdiv;
		}
		if(this.lookupStates.isShowed)
		{
			this.closeDropDown();
			return;
		}
		lookupdiv.appendTo($('body'));
		var base = {};
		base["entityId"] = this.state.data.entityId;
		base["innerId"] = null;
		base["componentItemName"] = null;
		base["formType"] = "Dialog";			
		this.lookupKey = FormLookupFactory.getKey(base);
		var moduleLookup = FormLookupFactory.createFormLookup(base,"PullDown");
	
		var lookup = ReactDOM.render(moduleLookup, lookupdiv.get(0));
		
		this.buildLookupArg(lookup);

		lookup.doDataProviderRefresh();

		if(typeof(lookup.queryBoxClear)==="function")
		{
			lookup.queryBoxClear();
		}

		/*var _parentWindow = window.parent.window;
	    if(_parentWindow)
	    {
	       _parentWindow.setToolBar(this.toolBarObject);
	    }*/

		this.onLookupCmp();
		this.attachEventListeners();
		this.inputField.focus();
		this.unsubscribeLookupReturnStore = LookupReturnStore.listen(this.onLookupReturn.bind(this));
		return true;
	}

	buildLookupArg(lookup)
	{
		lookup.lookupArg = {};
		lookup.lookupArg["editorFormType"] = "Dialog";
		lookup.lookupArg["groupAlias"] = null;
		lookup.lookupArg["baseTableName"] = null;
		lookup.lookupArg["filterFieldName"] = null;
		lookup.lookupArg["baseRecord"] = null;
		lookup.lookupArg["baseFormId"] = null;

		lookup.lookupArg["fieldName"] = StringUtil.convertToFirstUpperCase(lookup.returnField.split(".")[1]);
		
	}

	onLookupCmp()
	{
		var lookupdiv = this.lookupStates.dropdownform;
		var _inputwidth = $(this.inputgroup).width();//this.props.displayLengthWidth;
		var _iframewidth = lookupdiv.outerWidth();
		
		var _iframeheight = lookupdiv.outerHeight();
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();

		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.inputgroup).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+$(this.inputgroup).height();
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_y+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_y)
			{
				//上方空间大
				if(_y>(_gheight/2))
				{
					let _newdivheight = (_y-1)+'px';
					//lookupdiv.css("height":_newdivheight);
					lookupdiv.height(_y-2);
					//alert(_newdivheight);
					_top = '0px';
					//'-'+_newdivheight+'px';

				}
				else //下方空间大
				{
					//let _newdivheight = (_gheight-_y)+'px';
					lookupdiv.height(_gheight-_y);	
				}
			}
			else//下拉框置于上方
			{
				_top = (_y-_iframeheight)+'px';
					//'-'+_iframeheight+'px';
			}
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-5;
		if(_left<0)_left = 0;
		
		lookupdiv.css({left:(_left+'px'),top:_top});
		//lookupdiv.css({left:'860px',top:'200px'});
		
		this.lookupStates.isShowed = true;
	}

	attachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.applyEvents(this.lookupEvents);
	}

	unapplyEvents(evs)
	{
		for (var i=0, el, ev, ch; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.off(ev, ch);
		}
	}

	applyEvents(evs)
	{
		for (var i=0, el, ch, ev; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.on(ev, ch);
		}
	}


	//目前测试下来 react生命周期方法只有在超类显式定义才可以调用super
	componentDidMount()
	{	
		this.checkDropDownHas();
	}

	render()
	{
		let displayHeight=this.state.data.displayHeight;
		if(!displayHeight)
			displayHeight = 1;
		let displayLength=this.state.data.displayLength;
		if(!displayLength)
			displayLength = 20;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		let notNull=this.state.data.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		let label = this.state.data.label;
		if(displayHeight>1){
			let textAreaDom = this.getTextAreaDom(displayHeight);
			return(
				<div id={"Editor"+this.state.data.id} ref={node => this.element = node} className='editorGroup' style={editorStyle}>
					<label htmlFor={"input"+this.state.data.id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
						style={{paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'}}>
						{label}
						
					</label><i className='fa fa-snowflake-o' style={_notNullStyle}></i>
					<div className="input-group" ref={node=>this.inputgroup=node} style={{width:_width}}>
				       	{textAreaDom}
				    </div>
				</div>
			);
		}else{
			let inputdom = this.getInputDom(_width);
			let downArrowButtonDom = this.getDownArrowButtonDom();
			return(
				<div id={"Editor"+this.state.data.id} ref={node => this.element = node} className='editorGroup' style={editorStyle}>
					<label htmlFor={"input"+this.state.data.id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
						style={{paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'}}>
						{label}
					</label><i className='fa fa-snowflake-o' style={_notNullStyle}></i>
					<div className="input-group" ref={node=>this.inputgroup=node}>
				        {inputdom}{downArrowButtonDom}
				    </div>
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldStringEditor.js